import { render, staticRenderFns } from "./JDRow.vue?vue&type=template&id=e821cecc&scoped=true&"
import script from "./JDRow.vue?vue&type=script&lang=js&"
export * from "./JDRow.vue?vue&type=script&lang=js&"
import style0 from "./JDRow.vue?vue&type=style&index=0&id=e821cecc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e821cecc",
  null
  
)

export default component.exports